<template>
  <main>
    <section class="lot-search">
      <form class="lot-search__form" v-on:submit.prevent="doSearch">
        <label for="url">
          <i class="lot-search__fa-search"></i>
          <input id="url" class="lot-search__input"
                 type="text"
                 name="search"
                 :value="searchText"
                 :placeholder="$t('form.public-search.field.search-line.placeholder')"
                 @keyup="OnSearchKeyPressed" >
          <!--Отображение крестика Доп class search-close-active -->
          <i class="lot-search__fa-search-close" :class="{ 'search-close-active': searchResults.length > 0 }" ></i>
        </label>
        <!--Отображение списка Доп class search--active -->
        <div class="lot-search__tip" :class="{ 'search--active': searchResults.length > 0 }">
          <ul class="list-group">
            <li v-for="item in searchResults" class="list-group-item" @click="OnSearchItemSelect(item)">{{item}}</li>
          </ul>
        </div>
      </form>

      <div class="lot-search__advanced" v-if="useExtendedSearch">
        <div>
          <form action="" class="lot-search__advanced-form">
            <div class="lot-search__group-select">
              <div class="lot-search__select a-width-100-percent">
                <p>{{$t('form.public-search.field.categories.label')}}:</p>
                <categories-search class="select-w-570"
                                   multiple
                                   :placeholder="$t('form.public-search.field.categories.placeholder')"
                                   v-model="categories">
                </categories-search>
              </div>
              <div class="lot-search__select" style="max-width: 578px;width: 100%">
                <p style="width: 128px">{{$t('form.public-search.field.tender-stage.label')}}:</p>
                <label class="select-w-570">
                  <dropdown-new v-model="lotStatus"
                                multiple
                                :placeholder="$t('form.public-search.field.tender-stage.placeholder')"
                                :options="availableLotStatuses">
                  </dropdown-new>
                </label>
              </div>
            </div>
            <div class="lot-search__advanced-attr">
              <div class="lot-search__advanced-attr-data">
                <p>{{$t('form.public-search.field.publish-date.label')}}:</p>
                <div class="lot-search__input-group">
                  <p>{{$t('form.public-search.field.publish-date.from.label')}}:</p>
                  <date-picker v-model="publicationFrom"></date-picker>
                </div>
                <div class="lot-search__input-group">
                  <p>{{$t('form.public-search.field.publish-date.to.label')}}:</p>
                  <date-picker v-model="publicationTo"></date-picker>
                </div>
              </div>
              <div class="lot-search__advanced-attr-price">
                <p>{{$t('form.public-search.field.price.label')}}:</p>
                <label class="lot-search__advanced-against">
                  {{$t('form.public-search.field.price.from.label')}}:
                  <input-cost class="a-input a-input--w-166" v-model="priceFrom"></input-cost>
                </label>
                <label class="lot-search__advanced-until">
                  {{$t('form.public-search.field.price.to.label')}}:
                  <input-cost class="a-input a-input--w-166" v-model="priceTo"></input-cost>
                </label>
              </div>
            </div>
            <div class="lot-search__group-button">
              <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="OnResetFilters">{{$t('buttons.reset-filters')}}</button>
              <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="doSearch">{{$t('buttons.apply')}}</button>
            </div>
          </form>
        </div>
      </div>

      <button class="gui-btn gui-btn--search"
              v-t="'buttons.advanced-search'"
              @click="useExtendedSearch = !useExtendedSearch"></button>
    </section>

    <section class="procurement a-main-content" v-if="didSearch">
      <h2 class="procurement__header a-header" v-t="'purchases-link'"></h2>

      <div class="procurement__container">
        <div v-if="foundItems > 0">
          <div class="procurement__result">
            <p>{{$tc('form.public-search.search-result', foundItems)}}</p>
          </div>

          <div class="procurement__row-cards">
            <item-card :item="item"
                       :is-authorized="isAuthorized"
                       v-for="item in items" :key="item.id">
            </item-card>
          </div>

          <button class="gui-btn gui-btn--more"
                  @click.prevent="fetchMoteLots"
                  v-if="foundItems > items.length">
            {{$t('buttons.show-more')}}
          </button>
        </div>

        <div v-else>
          <div class="procurement__result">
            <p>{{$t('form.public-search.nothing-is-found')}}</p>
          </div>
        </div>

        <loading v-if="loading"></loading>
      </div>
    </section>
  </main>
</template>

<script>
  import _ from 'lodash'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'
  import ItemCard from "./ItemCard";

  export default {
    components: {
      ItemCard,
      CategoriesSearch
    },

    props: {
      search: {
        type: String,
        default: 'active'
      }
    },

    data: () => ({
      useExtendedSearch: false,
      publicationFrom: undefined,
      publicationTo: undefined,
      priceFrom: undefined,
      priceTo: undefined,
      searchText: '',
      searchResults: [],
      lotStatus: undefined,
      categories: undefined,
      didSearch: false
    }),

    computed: {
      foundItems() { return this.$store.state.search.publicLots.total },
      items() { return this.$store.state.search.publicLots.items },
      isAuthorized() { return this.$store.getters.isAuthorized },

      availableLotStatuses() {
        return this.search === 'archive' ? [
          { name: 'Все этапы' },
          { name: this.$t('lot-state.waiting-for-opening-protocol'), id: this.enums.LotState.WAITING_FOR_OPENING_PROTOCOL },
          { name: this.$t('lot-state.processing-requests'), id: this.enums.LotState.PROCESSING_REQUESTS },
          { name: this.$t('lot-state.estimating-requests'), id: this.enums.LotState.ESTIMATING_REQUESTS },
          { name: this.$t('lot-state.creating-retend'), id: this.enums.LotState.CREATING_RETEND },
          { name: this.$t('lot-state.waiting-for-retend'), id: this.enums.LotState.WAITING_FOR_RETEND },
          { name: this.$t('lot-state.waiting-for-resolution'), id: this.enums.LotState.WAITING_FOR_RESOLUTION },
          { name: this.$t('lot-state.processing-retend'), id: this.enums.LotState.PROCESSING_RETEND },
          { name: this.$t('lot-state.retend'), id: this.enums.LotState.RETEND },
          { name: this.$t('lot-state.dividing-price'), id: this.enums.LotState.DIVIDING_PRICE },
          { name: this.$t('lot-state.winner'), id: this.enums.LotState.WINNER },
          { name: this.$t('lot-state.closed'), id: this.enums.LotState.CLOSED },
          { name: this.$t('lot-state.cancelled'), id: this.enums.LotState.CANCELLED }
        ] : [
          { name: this.$t('lot-state.waiting-for-requests'),  id: this.enums.LotState.WAITING_FOR_REQUESTS }
        ];

        return options;
      }
    },

    watch: {
      isAuthorized() {
        this.doFetchPublicLots();
      },

      search() {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.doFetchPublicLots();
      }
    },

    async mounted() {
      this.doFetchPublicLots();
    },

    methods: {
      async doFetchPublicLots() {
        const query = _.pick(this.$route.query, [
          'text',
          'publicationDateFrom',
          'publicationDateTo',
          'priceFrom',
          'priceTo',
          'extended'
        ]);

        this.runAction(async () => {
          try {
            const filters = {
              text: query.text,
              isArchive: this.search === 'archive',
              publicationDateFrom: query.publicationDateFrom || undefined,
              publicationDateTo: query.publicationDateTo || undefined,
              priceFrom: query.priceFrom || undefined,
              priceTo: query.priceTo || undefined
            };

            this.useExtendedSearch = query.extended === 'true';

            this.searchText = filters.text;
            this.priceFrom = filters.priceFrom;
            this.priceTo = filters.priceTo;

            if (filters.publicationDateFrom) {
              this.publicationFrom = new Date(+filters.publicationDateFrom);
            }

            if (filters.publicationDateTo) {
              this.publicationTo = new Date(+filters.publicationDateTo);
            }

            await this.$store.dispatch('fetchPublicLots', filters);
            this.didSearch = true;
          }
          catch(e) {
            console.error('unable to fetch list of public lots', e);
          }
        });
      },

      async OnSearchKeyPressed(event) {
        this.searchResults = [];

        if (this._queryTimer) {
          clearTimeout(this._queryTimeout);
        }

        const text = event.target.value;
        this.searchText = text;

        if (text.length < 1) return;

        const requestId = Date.now();
        this._requestId = requestId;

        this._queryTimer = setTimeout(async () => {
          try {
            const results = await this.$store.dispatch('searchPublicLots', {
              text,
              archive: this.search === 'archive'
            });

            if (requestId === this._requestId) {
              this.searchResults = results;
            }
          }
          catch(e) {
          }
        }, 500);
      },

      OnSearchItemSelect(text) {
        this.searchText = text;
        this.searchResults = [];

        this.doSearch();
      },

      async doSearch() {
        this.runAction(async () => {
          try {
            const filters = {
              text: this.searchText || undefined,
              isArchive: this.search === 'archive',
              publicationDateFrom: +this.publicationFrom || undefined,
              publicationDateTo: +this.publicationTo || undefined,
              priceFrom: this.priceFrom,
              priceTo: this.priceTo,
              extended: this.useExtendedSearch,
              states: (this.lotStatus || []) || undefined,
              categories: (this.categories || []).map(e => e.id) || undefined
            };

            // this.$router.push({ name: this.$route.name, query: filters});

            await this.$store.dispatch('fetchPublicLots', filters);
            this.didSearch = true;
          }
          catch(e) {
          }
        });
      },

      async fetchMoteLots() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('fetchMorePublicLots');
          }
          catch(e) {
            console.error('unable to fetch list of more public lots', e);
          }
        });
      },

      OnResetFilters() {
        this.searchText = undefined;
        this.publicationFrom = undefined;
        this.publicationTo = undefined;
        this.priceFrom = undefined;
        this.priceTo = undefined;
        this.searchResults = [];
        this.categories = undefined;
        this.didSearch = false;
      }
    }
  }
</script>

<style scoped>

</style>
